import {
  FETCH_REVENUE_REQUEST,
  FETCH_REVENUE_SUCCESS,
  FETCH_REVENUE_FAILURE,
} from '../constants/revenueConstants';

export const fetchRevenueRequest = (params) => ({
  type: FETCH_REVENUE_REQUEST,
  payload: params,
});

export const fetchRevenueSuccess = (data) => ({
  type: FETCH_REVENUE_SUCCESS,
  payload: data,
});

export const fetchRevenueFailure = (error) => ({
  type: FETCH_REVENUE_FAILURE,
  payload: error,
});